import { getEnv } from '@/config/env'

export function cookieDomainApplies(domain: string, hostname: string): boolean {
  if (domain === '') return false

  const bare = domain.startsWith('.') ? domain.slice(1) : domain
  if (bare === '') return false

  return hostname === bare || hostname.endsWith(`.${bare}`)
}

export function sharedCookieDomain(): string {
  let configured: string

  try {
    configured = (getEnv().VITE_AUTH_COOKIE_DOMAIN ?? '').trim()
  } catch {
    return ''
  }

  const hostname = globalThis.location.hostname

  return cookieDomainApplies(configured, hostname) ? configured : ''
}
